import React from 'react';
import Slider from 'react-slick';

function Brand() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    arrows: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 4, slidesToScroll: 1 }
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 4, slidesToScroll: 1 }
      },
      {
        breakpoint: 575,
        settings: { slidesToShow: 2, slidesToScroll: 1, arrows: false , justifyContent: "center" }
      }
    ]
  };

  const containerStyle = {
    padding: "40px 0",
  };

  const itemStyle = {
    display: "flex",
    justifyContent: "center",
    padding: "10px",
    width: "100%",
  };

  const imgStyle = {
    maxHeight: "60px",
    width: "auto",
    objectFit: "contain",
  };
 
  return (
    <div style={containerStyle}>
      <div style={{ width: "90%", margin: "0 auto" }}>
        <Slider {...settings}>
          {[
  { id: "white", value: "Aaj_tak_logo.png" },
  { id: "white", value: "axiata logo.png" },
  { id: "black", value: "Dainik_Jagran_logo.png" },
  { id: "black", value: "Disney_wordmark.svg.png" },
  { id: "black", value: "electronic-arts-1-logo-png-transparent.png" },
  { id: "white", value: "estisalate.png" },
  { id: "black", value: "Gionee_logo.png" },
  { id: "black", value: "micromax.png" },
  { id: "black", value: "MONDIA_Brand_Print_Neu.png" },
  { id: "white", value: "MTN_Logo.svg.png" },
  { id: "black", value: "nazara logo.png" },
  { id: "white", value: "npimg.jpg" },
  { id: "white", value: "one97img.jpeg" },
  { id: "white", value: "oppoimg.jpg" },
  // { id: "black", value: "paytm.png" },
  { id: "white", value: "phonepayimg.png" },
  { id: "white", value: "Reliance_Jio_Logo_(October_2015).svg.png" },
  { id: "white", value: "ShareKaro.png" },
  { id: "white", value: "Shemaroo_Entertainment_Logo.png" },
  { id: "white", value: "ssd-techimg.png" },
  { id: "black", value: "Telenor_Logo.svg.png" },
  { id: "white", value: "Viu_(streaming_media)-Logo.wine.png" },
  { id: "white", value: "Vodafone-Logo-2006-2017.png" },
  { id: "white", value: "WinZO_Wiki.jpg.png" },
  { id: "white", value: "zain logo.png" }
].map((file, idx) => (
            <div key={idx} id={idx} style={itemStyle}>
             
              <img 
              
                src={`assets/img/brand/${file.value}`}
                alt={file}
                style={{filter: file.id === "black" ? "invert(1)":"none", 
                  ...imgStyle}}
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default Brand;
